import React, { useState, useEffect, useRef } from 'react';
import { withRouter } from 'react-router';
import './TerminosCondiciones.css';
import { ErrorBarra } from 'errores';
import useResizeEventIframe from '../Utils/Iframe';

var autenticado = false;
var cookie = null;
const TerminosCondiciones = (props) => {
    const divRef = useRef(null);
    const [terminosCondiciones, setTerminosCondiciones] = useState('');
    const [autorizacion, setAutorizacion] = useState(false);
    const [errorlabelAutorizacion, setErrorlabelAutorizacion] = useState(false);
    const { marca, servicio, servicioFirebase, callbackAceptoTerminos, padre = true } = props;
    const [cargando, setCargando] = useState(true);
    const [errorBarraMensaje, setErrorBarraMensaje] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [habilitaboton, setHabilita] = useState(false);
    const [inicialAutorizacion, setInicial] = useState(false);
    const [appId, setAppId] = useState(1)

    useEffect(() => {
        try {
            if (marca !== process.env.REACT_APP_MARCA_VW) {
                servicioFirebase.registrarVistaVisitadaAnalitica("TerminosCondiciones");
            }
        } catch (err) {
            console.error("terminos: ", err);
        }
        var b = document.cookie.match('(^|;)\\s*TCDTO\\s*=\\s*([^;]+)');
        cookie = b ? b.pop() : '';
        fetch(process.env.REACT_APP_URL_TERMINOS_VW + marca + ".json", {
            method: 'GET'
        }).then(fileJson => { return fileJson.json() }).then(json => {
            try {
                setTerminosCondiciones(json.texto);
                if (servicio !== undefined) {
                    servicio.getAutenticado()
                        .then(result => {
                            if (result === true) {
                                autenticado = true;
                                fetch(process.env.REACT_APP_URL_DTO_BACK_AUTH + `clientes/terminosycondiciones?&appId=${appId}`, {
                                    method: 'GET',
                                    headers: {
                                        "Authorization": "Bearer " + servicio.getToken()
                                    }
                                }).then(response => { return response.json() }).then(json => {
                                    try {
                                        if (json.mensaje[0]?.aceptado === true) {
                                            console.log("aceptado -> ok")
                                            setInicial(true);
                                            setAutorizacion(true);
                                            setCargando(false);
                                            if (padre === true)
                                                callbackAceptoTerminos(true);
                                        } else {
                                            setInicial(false);
                                            setCargando(false);
                                            console.log("aceptado -> not")
                                        }
                                    } catch (error) {
                                        setCargando(false);
                                    }
                                }).catch(error => {
                                    if (marca !== process.env.REACT_APP_MARCA_VW) {
                                        servicioFirebase.registrarErrorAnalitica(error, false);
                                    }
                                    setCargando(false);
                                    setErrorBarraMensaje('La respuesta del servidor no es correcta, inténtelo nuevamente. Si el problema persiste comuníquese con el equipo de soporte.');
                                });
                            } else {
                                setCargando(false);
                            }
                        }).catch(err => {
                            if (marca !== process.env.REACT_APP_MARCA_VW) {
                                servicioFirebase.registrarErrorAnalitica(err, false);
                            }
                            setCargando(false);
                        });
                } else {
                    if (cookie === "true" && padre === true) {
                        callbackAceptoTerminos(true);
                    }
                    setCargando(false);
                }
            } catch (error) {
                if (marca !== process.env.REACT_APP_MARCA_VW) {
                    servicioFirebase.registrarErrorAnalitica(error, false);
                }
                setCargando(false);
                setErrorBarraMensaje('La respuesta del servidor no es correcta, inténtelo nuevamente. Si el problema persiste comuníquese con el equipo de soporte.');
            }
        }).catch(error => {
            if (marca !== process.env.REACT_APP_MARCA_VW) {
                servicioFirebase.registrarErrorAnalitica(error, false);
            }
            setCargando(false);
            setErrorBarraMensaje('No se estableció conexión con el servidor inténtelo nuevamente.');
        });
        return () => { };
    }, [callbackAceptoTerminos, marca, servicio, padre, servicioFirebase]);

    const handleChange = () => {
        setAutorizacion(!autorizacion);
        inicialAutorizacion !== autorizacion ? setHabilita(!habilitaboton) : setHabilita(!habilitaboton)
    }

    const continuarOnClick = () => {
        setErrorlabelAutorizacion(false)
        if (!autorizacion && padre === true) {
            setErrorlabelAutorizacion(true)
            return
        }
        if (marca !== process.env.REACT_APP_MARCA_VW) {
            servicioFirebase.registrarEventoPersonalizadoAnalitica("action-continuar-terminosycondiciones", { marca: marca, descripcion: "Continuar Aceptados Terminos y Condiciones" });
        }
        setCargando(true);
        if (autenticado && servicio !== undefined) {
            fetch(process.env.REACT_APP_URL_DTO_BACK_AUTH + "clientes/terminosycondiciones", {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + servicio.getToken()
                },
                body: JSON.stringify(
                    {
                        "tyc": {
                            "appId": appId,
                            "aceptado": autorizacion
                        }
                    })
            }).then(response => { return response.json() }).then(json => {
                try {
                    if (json.statusCode === 200) {
                        if (padre === true) {
                            callbackAceptoTerminos(true);
                            setHabilita(false);

                        } else {
                            setShowModal(true);
                        }
                        setCargando(false);
                    } else {
                        setCargando(false);
                        setErrorBarraMensaje('La respuesta del servidor no es correcta, inténtelo nuevamente. Si el problema persiste comuníquese con el equipo de soporte.');
                    }
                } catch (error) {
                    if (marca !== process.env.REACT_APP_MARCA_VW) {
                        servicioFirebase.registrarErrorAnalitica(error, false);
                    }
                    setCargando(false);
                    setErrorBarraMensaje('La respuesta del servidor no es correcta, inténtelo nuevamente. Si el problema persiste comuníquese con el equipo de soporte.');
                }
            }).catch(error => {
                if (marca !== process.env.REACT_APP_MARCA_VW) {
                    servicioFirebase.registrarErrorAnalitica(error, false);
                }
                setCargando(false);
                setErrorBarraMensaje('No se estableció conexión con el servidor inténtelo nuevamente.');
            });
        } else {
            if (marca !== process.env.REACT_APP_MARCA_VW) {
                servicioFirebase.registrarEventoPersonalizadoAnalitica("action-no-autenticado", { marca: marca, descripcion: "Usuario no autenticado en terminos y condiciones" });
            }
            var fecha = new Date();
            fecha.setFullYear(fecha.getFullYear() + 100);
            document.cookie = "TCDTO=true;path=/;" + process.env.REACT_APP_SECURE + "expires=" + fecha.toUTCString() + ";domain=" + process.env.REACT_APP_DOMAIN_COOKIE + ';SameSite=None;';
            callbackAceptoTerminos(true);
        }
    }

    const cerrarOnClick = () => {
        if (marca !== process.env.REACT_APP_MARCA_VW) {
            servicioFirebase.registrarEventoPersonalizadoAnalitica("action-cierra-terminosycondiciones", { marca: marca, descripcion: "Cierra del modal en terminos y condiciones" });
        }
        let url = "";
        if (props.location.pathname.includes("terminosycondiciones")) {
            props.history.goBack();
        } else {
            switch (marca) {
                case "vw": url = "https://www.vw.com.mx/es.html"; break;
                case "seat": url = "https://www.seat.mx/"; break;
                case "audi": url = "https://www.audi.com.mx/mx/web/es.html"; break;
                default: url = "/consultar"; break;
            }
            window.top.location.href = url;
        }
    }

    const parseTerminosCondicionesJSON = (texto, index) => {
        if (typeof (texto) === 'string' && texto.indexOf("<b>") === 0) {
            return <b key={'b' + index}>{texto.replace("<b>", "")}</b>
        } else if (typeof (texto) === 'object') {
            if (texto.tipo.includes("<ol")) {
                return <ol key={index} style={{ listStyleType: texto.tipo === "<ol upper-alpha>" ? "upper-alpha" : "" }}>
                    {texto.opciones.map((li, indexIn) => {
                        return <li key={index + indexIn}>{parseTerminosCondicionesJSON(li, indexIn)}</li>
                    })}
                </ol>
            }
        }
        return texto
    }

    useResizeEventIframe(divRef);
    return (
        <div ref={divRef}>
            <div className={"page__cargando page__cargando--" + marca + (cargando ? " d-block" : " d-none")}><div className="terminos-back-pantalla-carga"></div> </div>
            {errorBarraMensaje !== '' && <ErrorBarra marca={marca} mensaje={errorBarraMensaje} cerrarError={() => { setErrorBarraMensaje("") }}></ErrorBarra>}
            <div className={"container terminos-contenedor container__font--" + marca}>
                <p className={"terminos--titulo terminos--titulo--" + marca}>Términos y Condiciones</p>
                <p className="mt-4 terminos--texto_chico">Por favor, para continuar debe leer y aceptar nuestros Términos y Condiciones</p>
                <div className="row justify-content-center mt-4">
                    <p><b>Términos y Condiciones</b></p>
                </div>
                <div className="row">
                    <div className="col-1 col-sm-1 col-md-2"></div>
                    <div className="col-10 col-sm-10 col-md-8">
                        <div className="terminos--texto_chico" style={{ whiteSpace: 'break-spaces' }}>{terminosCondiciones && terminosCondiciones.map((texto, index) => {
                            return parseTerminosCondicionesJSON(texto, index)
                        })}</div>
                    </div>
                    <div className="col-1 col-sm-1 col-md-2"></div>
                </div>
                <div className="row mt-3">
                    <div className="col-auto">
                        <label className={"container_check--" + marca}>
                            <input type="checkbox" id="autorizacion" name="autorizacion" checked={autorizacion} onChange={handleChange} />
                            <span className={"check--" + marca}></span>
                        </label>
                    </div>
                    <div className="ml-2 col col-md-10 mb-3">
                        <span className="terminos--texto_chico"> Al aceptar confirmas haber leido nuestros Términos y Condiciones.</span>
                    </div>
                    <span className={errorlabelAutorizacion ? "mb-3 form__errorlabel--" + marca + " terminos--error_label terminos--texto_chico" : "d-none"}>Aceptar Términos y Condiciones</span>
                </div>
                <div className="row mt-5 mb-5">
                    <div className="col-1 col-sm-12 col-md-3 col-lg-3"></div>
                    <div className="col-10 col-sm-12 col-md-6 col-lg-6">
                        <div className="row">
                            <div className="col-6">
                                <button className={"w-100 form__button--" + marca + "-ghost form__button--" + marca} name="recuperar" onClick={cerrarOnClick}>{props.location.pathname.includes("terminosycondiciones") ? "Regresar" : "Cerrar"}</button>
                            </div>
                            <div className="col-6">
                                <button onClick={continuarOnClick} disabled={!habilitaboton} className={"w-100 form__button--" + marca + (habilitaboton ? " form__button--" + marca + "-black" : "")}>Continuar</button>
                            </div>
                        </div>
                    </div>
                    <div className="col-1 col-sm-12 col-md-3 col-lg-3"></div>
                </div>
            </div>
            <div className={"modal fade show " + (showModal ? " d-block" : "d-none") + " form__modal container__font--" + marca} id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className={"form__close-button--" + marca} aria-label="Close" onClick={() => setShowModal(true)}>
                                <svg width="48" height="48" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                    <title>
                                        cancel-large
                                    </title>
                                    <path d="M31.6,15.4 L15.4,31.6 M15.4,15.4 L31.7,31.7" stroke="currentColor" strokeWidth="1" fill="none" fillRule="evenodd" />
                                </svg>
                            </button>
                        </div>
                        <div className="modal-body mr-3">
                            <h4 className={"mb-3 pasos__titulo--" + marca}>Aviso Importante</h4>
                            {
                                marca === "vw" ? (
                                    <div className="row">
                                        <p className="col-12">Los Términos y Condiciones han sido actualizados correctamente.</p>
                                    </div>
                                ) : <div className="row">
                                    <p className="col-12">Los Términos y Condiciones han sido actualizados correctamente.</p>
                                </div>
                            }
                        </div>
                        <div className="container">
                            <div className="row mt-3 mb-5 mb-2">
                                <div className="offset-4 col-4 mt-3">
                                    <button type="button" onClick={() => { setShowModal(false); setHabilita(false); setInicial(false) }} className={"w-100 form__button--" + marca + "-black form__button--" + marca}>Continuar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default withRouter(TerminosCondiciones);